import { Navigate, Route } from "react-router-dom";
import { NewProject, NewProjectV2, ProjectDetails, ListProject } from "../components";

const projectRoutes = [
  <Route index element={<Navigate to="list" replace />} key={"list:index"} />,
  <Route path="list" element={<ListProject />} key={"list"} />,
  <Route path="list/:id" element={<ProjectDetails />} key={"list:details"} />,
  <Route path="new" element={<NewProject />} key={"new"} />,
  <Route path="new-v2" element={<NewProjectV2 />} key={"new-v2"} />,
];
export default projectRoutes;
